/**
 * Convert text to URL-friendly slug
 * @param {string} text - The text to slugify
 * @returns {string} URL-friendly slug
 */
export const slugify = (text) => {
  if (!text) return '';
  
  // Handle React elements (when children is an array or object)
  if (typeof text !== 'string') {
    // If it's an array, join the text content
    if (Array.isArray(text)) {
      text = text.map(item => 
        typeof item === 'string' ? item : item?.props?.children || ''
      ).join('');
    } else if (text?.props?.children) {
      text = text.props.children;
    } else {
      text = String(text);
    }
  }
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w-]+/g, '')        // Remove all non-word chars
    .replace(/--+/g, '-')           // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};